(function () {
  function initCustomOptionsPopups() {
    document.querySelectorAll('script[id^="CustomOptionsData-"]').forEach(function (dataScript) {
      var sectionId = dataScript.id.replace('CustomOptionsData-', '');
      if (dataScript.dataset.initialized) return;
      dataScript.dataset.initialized = 'true';

      var config;
      try {
        config = JSON.parse(dataScript.textContent);
      } catch (e) {
        return;
      }

    var overlay = document.getElementById('CustomOptionsOverlay-' + sectionId);
var popup = document.getElementById('CustomOptionsPopup-' + sectionId);
var form = document.getElementById('product-form-' + sectionId);
if (!overlay || !popup || !form) return;

// Move popup + overlay to <body> to escape any parent transform
// (e.g. scroll-trigger animation wrappers) that breaks position:fixed
document.body.appendChild(overlay);
document.body.appendChild(popup);

      var submitBtn = document.getElementById('ProductSubmitButton-' + sectionId);
      var buttonsWrap = form.querySelector('.product-form__buttons');
      var paymentButtonWrap = buttonsWrap ? buttonsWrap.querySelector('.shopify-payment-button') : null;
      var quantityInput = document.getElementById('Quantity-' + sectionId);

      var errorEl = popup.querySelector('.custom-options-popup__error');
      var confirmBtn = popup.querySelector('.custom-options-popup__confirm');
      var closeBtn = popup.querySelector('.custom-options-popup__close');
      var select1 = popup.querySelector('[data-option="dropdown1"]');
      var select2 = popup.querySelector('[data-option="dropdown2"]');

      var pendingAction = null;

      function openPopup(action) {
        pendingAction = action;
        hideError();
        overlay.hidden = false;
        popup.hidden = false;
        requestAnimationFrame(function () {
          overlay.classList.add('is-open');
          popup.classList.add('is-open');
        });
      }

      function closePopup() {
        overlay.classList.remove('is-open');
        popup.classList.remove('is-open');
        setTimeout(function () {
          overlay.hidden = true;
          popup.hidden = true;
        }, 300);
      }
      function fieldError(name) {
        return config.txtPleaseSelect + name;
      }
      function showError(msg) {
        errorEl.textContent = msg;
        errorEl.hidden = false;
      }

      function hideError() {
        errorEl.hidden = true;
        errorEl.textContent = '';
      }

      function validate() {
       if (config.hasDropdown1 && select1 && !select1.value) {
          showError(fieldError(config.bundlePropertyName));
          return false;
        }
        if (config.hasDropdown2 && select2 && !select2.value) {
          showError(fieldError(config.cityPropertyName));
          return false;
        }
        return true;
      }

      function buildItems() {
        var items = [];
        var qty = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;

        var mainProperties = {};
        if (config.hasDropdown2 && select2 && select2.value) {
          mainProperties[config.cityPropertyName] = select2.value;
        }

        items.push({
          id: parseInt(config.mainVariantId, 10),
          quantity: qty,
          properties: mainProperties
        });

        if (config.hasDropdown1 && select1 && select1.value) {
          items.push({
            id: parseInt(select1.value, 10),
            quantity: 1,
            properties: {
              'أضيف مع': config.bundlePropertyName || ''
            }
          });
        }

        return items;
      }

      function addToCart() {
        confirmBtn.disabled = true;
        confirmBtn.textContent = config.txtAdding;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: buildItems() })
        })
          .then(function (res) {
            if (!res.ok) {
              return res.json().then(function (err) {
                throw new Error(err.message || 'حدث خطأ');
              });
            }
            return res.json();
          })
          .then(function () {
            closePopup();
            if (pendingAction === 'checkout') {
              window.location.href = '/checkout';
            } else {
              window.location.href = '/cart';
            }
          })
          .catch(function (err) {
            showError(err.message || config.txtError);
            confirmBtn.disabled = false;
            confirmBtn.textContent = config.txtConfirm;
          });
      }

      if (submitBtn) {
        submitBtn.addEventListener(
          'click',
          function (e) {
            e.preventDefault();
            e.stopImmediatePropagation();
            openPopup('cart');
          },
          true
        );
      }

      if (paymentButtonWrap) {
        paymentButtonWrap.style.display = 'none';

        var buyNowBtn = document.createElement('button');
        buyNowBtn.type = 'button';
        buyNowBtn.className = 'button button--secondary button--full-width custom-options-buy-now';
        buyNowBtn.textContent = config.txtBuyNow;
        buyNowBtn.addEventListener('click', function (e) {
          e.preventDefault();
          openPopup('checkout');
        });
        paymentButtonWrap.insertAdjacentElement('afterend', buyNowBtn);
      }

      confirmBtn.addEventListener('click', function () {
        hideError();
        if (!validate()) return;
        addToCart();
      });

      closeBtn.addEventListener('click', closePopup);
      overlay.addEventListener('click', closePopup);
    });
  }

  document.addEventListener('DOMContentLoaded', initCustomOptionsPopups);
  document.addEventListener('shopify:section:load', initCustomOptionsPopups);
})();